/* eslint-disable react/prop-types, no-shadow, no-unused-vars, react/no-multi-comp */
import React from 'react';
import { t } from 'es6/services/localization';
import { pauseEvents, pause, resume, isPaused } from 'es6/services/pause';
import BasicModal from 'es6/components/common/modals/basic';
import BaseModal from 'es6/components/common/modals/base';
import Config from 'es6/core/config';
import Glyph, { PAUSE, GEAR, CROSS } from 'es6/components/common/glyph';

export default class ScreenBanner extends React.Component {
  constructor() {
    super();

    this.state = { isSettingsModalOpen: false };

    this._openSettingsModal = () => {
      pause();
      this.setState({ isSettingsModalOpen: true });
    };
    this._closeSettingsModal = () => {
      resume();
      this.setState({ isSettingsModalOpen: false });
    };
  }

  render() {
    const {
      showPauseButton,
      showSettingsButton,
      renderSettingsModalContents,
      onQuit,
      children,
    } = this.props;
    const { isPaused, isSettingsModalOpen } = this.state;

    const pauseProps = { isSettingsModalOpen };
    const settingsProps = {
      isSettingsModalOpen,
      renderSettingsModalContents,
      onOpen: this._openSettingsModal,
      onClose: this._closeSettingsModal,
    };

    return (
      <div>
        <div className="control_panel">
          {showPauseButton && <PauseButton {...pauseProps} />}
          {showSettingsButton && <SettingsButton {...settingsProps} />}
          <QuitButton onClick={onQuit} />
        </div>

        {children && <div className="screen-banner">{children}</div>}
      </div>
    );
  }

}

ScreenBanner.propTypes = {
  showPauseButton: React.PropTypes.bool.isRequired,
  showSettingsButton: React.PropTypes.bool.isRequired,
  renderSettingsModalContents: React.PropTypes.func,
  onQuit: React.PropTypes.func,
};

class PauseButton extends React.Component {
  constructor() {
    super();

    this._update = () => this.forceUpdate();
  }

  componentDidMount() {
    // Re-render the pause modal when paused/resumed.
    pauseEvents.on('pause', this._update);
    pauseEvents.on('resume', this._update);
  }

  componentWillUnmount() {
    pauseEvents.removeListener('pause', this._update);
    pauseEvents.removeListener('resume', this._update);
  }

  render() {
    const { isSettingsModalOpen } = this.props;

    // Don't show the pause modal if the settings modal is open, too.
    const isOpen = isPaused() && !isSettingsModalOpen;

    return (
      <span className="button" onClick={pause}>

        <Glyph type={PAUSE} />

        <BaseModal isOpen={isOpen} onOverlayClick={resume}>
          <section className="content-container pause-modal" onClick={resume}>
            <div className="content-primary">
              {t('application-paused-explanation')}
            </div>
          </section>
        </BaseModal>
      </span>
    );
  }
}

function SettingsButton({ isSettingsModalOpen, renderSettingsModalContents, onOpen, onClose }) {
  return (
    <span className="button" onClick={onOpen}>
      <Glyph type={GEAR} />

      <BasicModal isOpen={isSettingsModalOpen} onClose={onClose}>
        {renderSettingsModalContents && renderSettingsModalContents(onClose)}
      </BasicModal>
    </span>
  );
}

function QuitButton({ onClick }) {
  return (
    <a href={Config.getReferrerURL()} className="blue button" onClick={onClick}>
      <Glyph type={CROSS} />
    </a>
  );
}
